import { ReactElement } from "react";
import { ViewerApi } from "@bronte/viewer-api/src/main";
import "./styles.scss";

interface ISearchDrawer {
  viewerApi: ViewerApi;
  onClose: () => void;
}

export const SearchDrawer = ({ onClose }: ISearchDrawer): ReactElement => {
  return (
    <div className="drawer search-drawer">
      <div className="header">
        <h3 className="title">Search</h3>
        <button className="close-button" aria-label="Close button" onClick={onClose}>
          <div className="close-icon" />
        </button>
      </div>

      <div className="drawer-body"></div>
    </div>
  );
};
